import LpSecondParam from './step_param';

/*
 * Project: LegalPlace assistant
 * File: src/app/refs/step2.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

const STEP = 'step_two_only';


class LpStepTwoRef {
  constructor() {
    this.ts_options = {};
    this.ts_variables = {};
    this.ts_sections = {};
  }

  buildOptions(opts) {
    const keys = Object.keys(opts);
    keys.forEach((idx) => {
      const now = opts[idx];
      if (now.meta[STEP]) {
        this.ts_options[idx] = new LpSecondParam();
      }
    }, this);
  }

  buildVariables(vars) {
    const keys = Object.keys(vars);
    keys.forEach((idx) => {
      const now = vars[idx];
      if (now[STEP]) {
        this.ts_variables[idx] = new LpSecondParam();
      }
    }, this);
  }

  buildSections(sections) {
    const keys = Object.keys(sections);
    keys.forEach((idx) => {
      const now = sections[idx];
      if (now[STEP]) {
        this.ts_sections[idx] = new LpSecondParam();
      }
    }, this);
  }
}


export default LpStepTwoRef;



// WEBPACK FOOTER //
// ./src/app/refs/step2.js